
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/delighted",
      function () {
        return require("private-next-pages/destinations/delighted.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/delighted"])
      });
    }
  